import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.sass';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { useIsMobile } from 'hooks/useIsMobile'
import { decodeStorage } from 'functions/storageBase64';

export function MenuCredito() {
    const sears_numero_internet = decodeStorage("sears_numero_internet")
    const { isMobile } = useIsMobile()

    return (
        <>
            {isMobile
                ? isMobile === 'desktop' &&
                    <nav className="menuCredito">
                        {sears_numero_internet 
                            ?
                                <ul className="ulMiCredito">
                                    <li className="titleMiCredito">Mi Crédito Sears</li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`} activeClassName="active">Mis Tarjetas</NavLink></li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}movimientos-tarjeta`} activeClassName="active">Movimientos</NavLink></li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}solicitar-estado-cuenta`} activeClassName="active">Estado de cuenta</NavLink></li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}pago-express`} activeClassName="active">Pago express</NavLink></li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta`} activeClassName="active">Agregar tarjeta</NavLink></li>
                                </ul>
                            :
                                <ul className="ulMiCredito">
                                    <li className="titleMiCredito">Crédito Sears</li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta`} activeClassName="active">Registrar tarjeta</NavLink></li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-sears`} activeClassName="active">Solicita tu tarjeta</NavLink></li>
                                    <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}pago-express`} activeClassName="active">Pago express</NavLink></li>
                                </ul>
                        }

                        <ul className="ulConoce">
                            <li className="titleConoce">Conoce Crédito Sears</li>
                            <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}beneficios`} activeClassName="active">Beneficios y Promociones</NavLink></li>
                            {sears_numero_internet 
                                ?
                                    <>
                                        <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-sears`} activeClassName="active">Solicita tu tarjeta</NavLink></li>
                                        <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}consultar-estatus-solicitud`} activeClassName="active">Consultar estatus de la solicitud</NavLink></li>
                                    </>
                                : null
                            }
                            <li className="opc"><a href={`https://serviciosgfi.inbursa.com:4070/multiplataforma/mvc/others/autotalPublico/init?ca=PUBLICO&pa=P&pro=SEARS#no-back-button`} target="_blank" rel="noopener noreferrer">Autotal Inbursa</a></li>
                            {/* <li className="opc"><NavLink to={`${BASE_PATH}${SUB_DIRECTORY}puntos-sears`} activeClassName="active">Puntos Sears</NavLink></li> */}
                        </ul>
                    </nav>
                : null
            }
        </>
    )
}